export default "__VITE_ASSET__c5654615__"